import posthog from 'posthog-js';

export function initPostHog() {
  const key = import.meta.env.VITE_POSTHOG_KEY;
  if (!key) return;

  posthog.init(key, {
    api_host: '/ph',
    ui_host: 'https://eu.posthog.com',
    person_profiles: 'always',
    autocapture: {
      dom_event_allowlist: ['click'],
      url_allowlist: ['.*'],
      element_allowlist: ['button', 'a'],
      css_selector_allowlist: ['[data-ph-capture]'],
    },
    mask_all_text: true,
    mask_all_element_attributes: true,
    capture_pageview: false,
    loaded: (ph) => {
      if (import.meta.env.DEV) ph.opt_out_capturing();
    },
  });
}

export { posthog };
